import React from 'react'
import { Modal, ModalNavHeader, FlexRow, Button, FlexColumn, Message } from 'elements'
import ChoiceButton from 'components/ui/input/ChoiceButton'
import IntegrationChoices from './IntegrationChoices'

export default function CreateReportSelectSource({
  modal,
  selected,
  onChange,
  onNext,
  integrationResult,
  company,
}) {
  const handleContinue = () => {
    if (selected?.href) {
      window.location.href = selected.href
    } else {
      onNext()
    }
  }

  const modalActions = [
    {
      label: 'Help',
      value: 'help',
      onSelect: () => window.open('https://scrutinize.io/howitworks', '_blank'),
    },
  ]

  return (
    <>
      <ModalNavHeader
        onClose={modal.onClose}
        actionOptions={modalActions}
        titleText="Create Report"
      />
      <FlexColumn p="xxlarge" pt="large" pb="xgigantic">
        {integrationResult?.status === 'success' ? (
          <Message kind="success" mb="xlarge">
            Your account was connected successfully!
          </Message>
        ) : null}
        {integrationResult?.status === 'error' ? (
          <Message kind="danger" mb="xlarge">
            Your account could not be connected.
          </Message>
        ) : null}
        <FlexRow mb="large">
          <IntegrationChoices company={company} selected={selected} onSelect={onChange} />
        </FlexRow>
        <FlexRow mb="large">
          <ChoiceButton
            icon="document-add"
            selected={selected === 'upload'}
            onPress={() => onChange('upload')}
          >
            Upload Files
          </ChoiceButton>
        </FlexRow>
      </FlexColumn>
      <Modal.Footer display="flex" alignItems="center">
        <Button mr="medium" kind="secondary" onPress={handleContinue}>
          Continue
        </Button>
        <Button onPress={modal.onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </>
  )
}
